import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=24c2f8e4&scoped=true&"
import script from "./concept.vue?vue&type=script&lang=js&"
export * from "./concept.vue?vue&type=script&lang=js&"
import style0 from "./concept.vue?vue&type=style&index=0&id=24c2f8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2f8e4",
  null
  
)

export default component.exports